<template>
  <div v-if="loader.isLoading" class="global-loader">
    <!-- exemplo com spinner do vue3-spinners -->
    <HalfCircleSpinner :size="100" color="#DF523A" :animation-duration="1000" />
  </div>
</template>

<script setup>
import { useLoaderStore } from '@/stores/loader'
import { HalfCircleSpinner } from 'epic-spinners'
const loader = useLoaderStore()
</script>

<style>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>
